import { render, staticRenderFns } from "./yoyo-sidebar-nav.vue?vue&type=template&id=755fe2e8&scoped=true"
import script from "./yoyo-sidebar-nav.vue?vue&type=script&lang=js"
export * from "./yoyo-sidebar-nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755fe2e8",
  null
  
)

export default component.exports